module.exports = __webpack_public_path__ + "img/Text.0fa1fd19.svg";